module.exports = __webpack_public_path__ + "images/emoji/earth_africa.687de2c10f6cb11082b9.png";